import {
    UPDATE_PRODUCT_PROPERTY,
    UPDATE_PRODUCT_PROPERTY_FAILURE,
    UPDATE_PRODUCT_PROPERTY_SUCCESS,
} from 'store/actions/types';

// Update Product Property
export const updateProductProperty = (payload) => {
    return {
        type: UPDATE_PRODUCT_PROPERTY,
        payload: payload,
    };
};

export const updateProductPropertyFailure = (error) => {
    return {
        type: UPDATE_PRODUCT_PROPERTY_FAILURE,
        error: error,
    };
};

export const updateProductPropertySuccess = (payload) => {
    return {
        type: UPDATE_PRODUCT_PROPERTY_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/productProperties/updateProductProperties.js